var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 29,
    viewBox: "0 0 18 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2861 22.3914L10.5303 4.24123L12.3275 3.65723L17.9999 21.5308L17.8179 21.8919L16.2861 22.3914Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8374 25.1655L1.16504 7.29201L2.96988 6.70801L8.73325 24.8582L7.2014 25.35L6.8374 25.1655Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16138 7.29127L1.7417 9.12012L12.9028 5.4837L12.3225 3.65485L1.16138 7.29127Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81203e-06 3.636L0.580322 5.46484L11.7415 1.82843L11.1611 -0.000419632L4.81203e-06 3.636Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05005 22.7034L6.63037 24.5322L17.7915 20.8958L17.2112 19.067L6.05005 22.7034Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49048 26.0262L17.1507 23.2061L15.9298 25.6189L10.8792 27.2633L8.49048 26.0262Z",
    fill: "#C4C4C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5325 28.1244L13.397 26.4185L14.5193 24.1977L16.3166 20.6553L18.0001 21.5313L17.8181 21.8924L17.1507 23.2064L15.9298 25.6193L15.8085 25.8652L15.126 27.2099L15.0805 27.2945L14.216 29.0004L12.5325 28.1244Z",
    fill: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8374 25.1657L7.7019 23.4521L11.0462 25.1965L13.397 26.4183L13.4273 26.4336L15.0805 27.2943L14.216 29.0002L6.8374 25.1657Z",
    fill: "#C4C4C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditEmail);
export default __webpack_public_path__ + "static/media/edit-email.6e53313db12c56fb51be318958ccaf8d.svg";
export { ForwardRef as ReactComponent };